import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { getUrlQuery } from '@/utils/urlQuery'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/loginByThirdSystem'] // no redirect whitelist
// whiteList[0] = baseIndex
var query = getUrlQuery()
const redirect = query.redirect
console.info('url-redirect->', redirect)
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login' || to.path === '/loginByThirdSystem') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      const { systems } = await store.dispatch('user/getInfo')
      if (process.env.NODE_ENV === 'development') {
        next()
      } else {
        console.info('redirect-systems->', systems)
        console.info('redirect-systems-chekc->', check(systems, redirect))
        if (check(systems, redirect)) {
          window.location.href = redirect
        } else if (systems.length === 1) {
          window.location.href = systems[0].url
        }
        next()
      }
    }
  } else {
    /* has no token*/
    console.info('whiteList', whiteList.indexOf(to.path), to.path)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next('/login') //
      NProgress.done()

      //
      //
    }
  }
})

function check(systems, redirect) {
  if (systems !== 'undefined' && systems !== null) {
    for (let i = 0; i < systems.length; i++) {
      const system = systems[i]
      if (system.url === redirect) {
        return true
      }
    }
  }
  return false
}

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
